import styled from 'styled-components';

export const Scrim = styled.div`
  position: fixed;
  inset: 0;
  background: rgba(20, 30, 40, 0.16);
  z-index: 900;
`;

export const Panel = styled.aside`
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  width: 440px;
  max-width: 100vw;
  background: #fff;
  box-shadow: -8px 0 24px rgba(0, 0, 0, 0.08);
  z-index: 901;
  display: flex;
  flex-direction: column;
  font-family: 'Inter', sans-serif;
  color: #303030;
`;

export const Header = styled.div`
  padding: 16px 18px 10px;
  border-bottom: 1px solid #eee;
`;

export const HeaderTop = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 8px;
`;

export const NcmCode = styled.div`
  font-size: 19px;
  font-weight: 700;
`;

export const Breadcrumb = styled.div`
  font-size: 11px;
  color: #999;
  margin: 2px 0 6px;
`;

export const Description = styled.div`
  font-size: 13px;
  color: #505050;
  margin-bottom: 8px;
`;

export const Chips = styled.div`
  display: flex;
  gap: 6px;
  flex-wrap: wrap;
  margin-bottom: 10px;
  align-items: center;
`;


export const CloseButton = styled.button`
  margin-left: auto;
  height: 28px;
  width: 28px;
  border-radius: 999px;
  border: 1px solid #d9d9d9;
  background: #fff;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  color: #696969;
`;

export const Tabs = styled.div`
  display: flex;
  gap: 6px;
`;

export const Tab = styled.button<{ $active?: boolean }>`
  font: 700 12px 'Inter', sans-serif;
  border: 2px solid ${({ $active }) => ($active ? '#0090D3' : '#ebebeb')};
  background: ${({ $active }) => ($active ? '#E6F4FB' : '#fff')};
  color: ${({ $active }) => ($active ? '#0090D3' : '#696969')};
  border-radius: 100px;
  padding: 5px 14px;
  cursor: pointer;
  display: inline-flex;
  gap: 6px;
  align-items: center;
`;

export const Count = styled.span`
  display: inline-block;
  font-size: 11px;
  font-weight: 700;
  border-radius: 100px;
  padding: 1px 8px;
  background: #ebebeb;
  color: #696969;
`;

export const Body = styled.div`
  padding: 14px 18px;
  overflow-y: auto;
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const Footer = styled.div`
  padding: 10px 18px;
  border-top: 1px solid #eee;
  font-size: 11px;
  color: #999;
`;

export const RuleCard = styled.div`
  border: 1px solid #eee;
  border-radius: 8px;
  padding: 12px;
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const RuleCardTitle = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 11px;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: #696969;
  font-weight: 700;
`;

export const TaxSection = styled.div`
  padding: 8px 0;
  border-top: 1px solid #f0f0f0;
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const SectionHead = styled.label`
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.06em;
  text-transform: uppercase;

  input {
    accent-color: #0090d3;
    width: 15px;
    height: 15px;
    margin: 0;
  }
`;

export const SectionHint = styled.span`
  font-size: 11px;
  color: #999;
  margin-left: auto;
  text-transform: none;
  letter-spacing: 0;
  font-weight: 400;
`;

export const FieldGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 8px;
`;

export const Field = styled.div<{ $full?: boolean }>`
  grid-column: ${({ $full }) => ($full ? '1 / -1' : 'auto')};

  label {
    display: block;
    font-size: 11px;
    color: #696969;
    margin-bottom: 3px;
    font-weight: 600;
  }

  select,
  input {
    box-sizing: border-box;
    width: 100%;
    height: 32px;
    border-radius: 20px;
    border: 1px solid transparent;
    background: #ebebeb;
    padding: 0 12px;
    font: 13px 'Inter', sans-serif;
    color: #303030;
    outline: none;
  }

  select:focus,
  input:focus {
    border-color: #3b82f6;
  }

  input:disabled,
  select:disabled {
    color: #999;
    cursor: not-allowed;
  }
`;

export const Note = styled.div`
  font-size: 11px;
  color: #999;
`;

export const CardActions = styled.div`
  display: flex;
  gap: 8px;
  justify-content: flex-end;
  align-items: center;
`;

export const PrimaryButton = styled.button`
  height: 32px;
  font: 700 12px 'Inter', sans-serif;
  padding: 0 14px;
  color: #fff;
  background: #0090d3;
  border-radius: 2rem;
  border: 0;
  cursor: pointer;

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
`;

export const MiniButton = styled.button<{ $danger?: boolean }>`
  height: 26px;
  font: 600 11px 'Inter', sans-serif;
  padding: 0 10px;
  border-radius: 100px;
  border: 1px solid #d9d9d9;
  background: #fff;
  color: ${({ $danger }) => ($danger ? '#a33a4e' : '#696969')};
  cursor: pointer;
  white-space: nowrap;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;

  &:hover {
    border-color: ${({ $danger }) => ($danger ? '#a33a4e' : '#0090d3')};
  }
`;

export const Segmented = styled.div`
  display: inline-flex;
  background: #e9e9e9;
  border-radius: 100px;
  padding: 3px;
  align-self: flex-start;
`;

export const SegmentedButton = styled.button<{ $active?: boolean }>`
  font: 700 11.5px 'Inter', sans-serif;
  border: 0;
  background: ${({ $active }) => ($active ? '#fff' : 'none')};
  color: ${({ $active }) => ($active ? '#0090D3' : '#696969')};
  border-radius: 100px;
  padding: 5px 12px;
  cursor: pointer;
`;

export const ListHead = styled.div`
  display: flex;
  align-items: center;
  font-size: 13px;
  font-weight: 700;
`;

export const LinkRow = styled.div`
  display: grid;
  grid-template-columns: 1fr auto;
  gap: 6px;
  align-items: center;
  padding: 9px 0;
  border-top: 1px solid #f0f0f0;

  &:first-child {
    border-top: 0;
  }
`;

export const LinkName = styled.button`
  border: 0;
  background: none;
  padding: 0;
  text-align: left;
  cursor: pointer;
  font-family: 'Inter', sans-serif;
  color: #303030;
  display: flex;
  flex-direction: column;

  b {
    font-size: 12.5px;
  }

  span {
    font-size: 11px;
    color: #999;
  }
`;

export const RowButtons = styled.span`
  display: flex;
  gap: 5px;
`;

export const Inline = styled.div`
  grid-column: 1 / -1;
  background: #fafafa;
  border-radius: 8px;
  padding: 9px;
  display: flex;
  gap: 6px;
  align-items: center;
  flex-wrap: wrap;
  font-size: 12px;

  select,
  input {
    box-sizing: border-box;
    min-width: 0;
    height: 28px;
    flex: 1 1 140px;
    border-radius: 20px;
    background: #fff;
    border: 1px solid #0090d3;
    padding: 0 10px;
    font: 12px 'Inter', sans-serif;
    outline: none;
  }
`;

export const InlineHint = styled.span`
  flex-basis: 100%;
  color: #696969;
  font-size: 11.5px;
`;

export const Summary = styled.dl`
  grid-column: 1 / -1;
  background: #f7f9fb;
  border-radius: 8px;
  padding: 10px;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 8px;
  font-size: 12px;
  margin: 0;

  dt {
    font-size: 10.5px;
    color: #999;
  }

  dd {
    margin: 2px 0 0;
    font-weight: 600;
    overflow-wrap: anywhere;
  }
`;

export const SummaryOrders = styled.div`
  grid-column: 1 / -1;
  border-top: 1px solid #e8edf2;
  padding-top: 6px;
  display: flex;
  flex-direction: column;
  gap: 3px;

  div {
    display: flex;
    justify-content: space-between;
    gap: 8px;
  }
`;

export const Muted = styled.span`
  color: #999;
`;

export const Empty = styled.div`
  font-size: 12px;
  color: #999;
  padding: 10px 0;
`;

export const FirstTaxSection = styled(TaxSection)`
  border-top: 0;
  padding-top: 0;
`;

export const AddRuleActions = styled(CardActions)`
  justify-content: flex-start;
  flex-wrap: wrap;
`;

export const PushRightButton = styled(MiniButton)`
  margin-left: auto;
`;

export const CandidateRow = styled(LinkRow)`
  flex-basis: 100%;
`;

export const SummaryWide = styled.div`
  grid-column: 1 / -1;
`;

export const OpcoesNcm = styled.div`
  flex-basis: 100%;
  max-height: 210px;
  overflow-y: auto;
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
`;
